import React from "react";
import Link from "gatsby-link";

import BackIcon from "react-icons/lib/fa/chevron-left";
import ForwardIcon from "react-icons/lib/fa/chevron-right";

import "./prevnext.css";

// eslint-disable-next-line react/prop-types
export default function Tags({ prev, next }) {
  return (
    <nav className="prevNextNav">
      {prev &&
        <h4 className="prev">
          <Link className="link prev" to={prev.frontmatter.path}>
            <BackIcon /> {prev.frontmatter.title}
          </Link>
        </h4>
      }
      {next &&
        <h4 className="next">
          <Link className="link next" to={next.frontmatter.path}>
            {next.frontmatter.title} <ForwardIcon />
          </Link>
        </h4>
      }
      <div className="cl" />
    </nav>
  );
}



// WEBPACK FOOTER //
// ./src/components/PrevNextNav/index.jsx